import React, { useState } from 'react';
import { Icon, Modal, Button } from 'antd';
import { Text3 } from '../../../styles';


const AlertBox = (props) => {
    const renderIcon = () => {
        let config = {};
        switch (props.type) {
            case "success":
                config.color = "green"
                config.type = "check-circle"
                break;
            case "warning":
                config.color = "yellow"
                config.type = "info-circle"
                break;
            case "error":
                config.color = "error"
                config.type = "exclamation-circle"
                break;
            default:
                config.color = "light"
                config.type = "check-circle"
                break;
        }
        return (
            <Icon style={{ fontSize: 24 }} theme="twoTone" twoToneColor={config.color} type={config.type} />
        )
    };

    const renderTitle = () => {
        return (
            <Text3 className="d-block mb-1">{props.title}</Text3>
        )
    };

    return (
        <Modal
            visible={props.visible}
            title={false}
            closable={false}
            maskClosable={false}
            centered={true}
            destroyOnClose={true}
            footer={null}
        >
            <div className="d-flex">
                <div className="mr-3">{renderIcon()}</div>
                <div>
                    {renderTitle()}
                    {props.content}
                </div>
            </div>
            <div className="d-flex justify-content-end">
                <Button type="primary" onClick={props.toggleAlertBox}>OK</Button>
            </div>
        </Modal>
    )
};

AlertBox.defaultProps = {
    visible: false,
    type: "success",
    title: "Title",
    content: <></>,
    okText: "Ok",
    cancelText: 'Cancel',
    onOk: () => { },
    onCancel: () => { },
};

export { AlertBox };
